import axios from "axios"
import * as actions from "../actions/employee"

import { formatDatetimeLocal } from '../js/utils'

function buildFormDataFromEmployee(employee) {
  // create FormData object to send as request instead of normal json data
  // this will make the request multipart and will split each parameter with a boundary
  // multipart is needed when uploading a file
  let data = new FormData()
  let employeePropertyNames = Object.keys(employee)
  for (let i = 0; i < employeePropertyNames.length; i++) {
    let employeePropertyName = employeePropertyNames[i]
    let propertyValue = employee[employeePropertyName]
    if (propertyValue) {
      if (employeePropertyName === 'RestrictionLookup' || employeePropertyName === 'EmployeeTypeLookup') {
        // stringfiy lookup since it is an object so we can deserialise into an object server side
        // otherwise it will be sent as [object Object]
        data.append(employeePropertyName, JSON.stringify(propertyValue))
      } else if (employeePropertyName === 'StartDate' || employeePropertyName === 'EndDate' || employeePropertyName === 'RestrictionStartDate' || employeePropertyName === 'RestrictionEndDate') {
        let formattedDate = formatDatetimeLocal(propertyValue)
        data.append(employeePropertyName, formattedDate)
      } else {
        data.append(employeePropertyName, propertyValue)
      }
    }
  }
  return data
}

export function addEmployee(employee) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      let data = employee
      let url = process.env.REACT_APP_API_HOST + "/api/employee"

      // if uploading file then build up FormData to send as multipart/form-data
      if (employee.StatDecFileData) {
        data = buildFormDataFromEmployee(employee)
        url = process.env.REACT_APP_API_HOST + "/api/employee/with-stat-dec"
      }
      axios.post(url, data)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.addEmployeeToLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getEmployeesForLobbyist(lobbyistId) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/employee?lobbyistId=" + lobbyistId)
      .then((response) => {
        let lobbyistEmployees = response.data ? response.data.$values : []
        dispatch(actions.getEmployeesForLobbyist(lobbyistEmployees))
      })
  }
}

export function getEmployeesForLobbyistByDate(lobbyistId, StartDate, EndDate) {
  return (dispatch) => {
    let url = `/api/employee?lobbyistId=${lobbyistId}&startDate=${StartDate}&endDate=${EndDate}`
    return axios.get(process.env.REACT_APP_API_HOST + url)
      .then((response) => {
        let employeesForLobbyistByDate = response && response.data ? response.data.$values : []
        dispatch(actions.getEmployeesForLobbyistByDate(employeesForLobbyistByDate));
        return response;
      })
  }
}

export function getEmployee(employeePayload) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/employee/" + employeePayload.type + '/' + employeePayload.employeeId)
      .then(response => dispatch(actions.getEmployee(response.data)))
  }
}

export function updateEmployee(employee) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      let data = employee
      let url = process.env.REACT_APP_API_HOST + "/api/employee"

      // if uploading file then build up FormData to send as multipart/form-data
      if (employee.StatDecFileData) {
        data = buildFormDataFromEmployee(employee)
        url = process.env.REACT_APP_API_HOST + "/api/employee/with-stat-dec"
      }
      axios.put(url, data)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.updateEmployeeForLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function deleteEmployee(employeeId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.delete(process.env.REACT_APP_API_HOST + "/api/employee/" + employeeId)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.removeEmployeeFromLobbyist(employeeId))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function clearEmployee() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearEmployee())
      resolve()
    })
  }
}


export function clearEmployeesFromLobbyist() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearEmployeesFromLobbyist())
      resolve()
    })
  }
}

export function getEmployeeStatDec(employeeId) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/employee/" + employeeId + "/stat-dec", {
      // VERY IMPORTANT - none of the files that get returned will open correctly without this
      responseType: 'blob'
    })
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/employee.js